export default {"src":"/_next/static/media/battery-health-bg.38e0e220.svg","height":85,"width":100};